import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-invanal",
  "use": "icon-invanal-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-invanal\"><path d=\"M0 0h448v448H0V0z m64 64v320h320V64H64zM576 576h448v64H576V576zM576 768v64h320v-64H576zM576 960h448v64H576v-64zM576 0v64h448V0H576zM576 192h320v64H576V192zM576 384v64h448V384H576zM0 576h448v448H0V576z m64 64v320h320v-320H64z\" fill=\"#ffffff\" p-id=\"37818\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol